import React, { useState } from "react";

import { useDocTitle, useForm } from "../../utils/hooks";
import Accordion from "../common/Accordion";
import { changePass } from "../../services/user";
import { useAPIs } from "../../apis/APIsConfig";
import { useGlobalStore } from "../../utils/global";

function ChangePassword() {
  useAPIs();
  useDocTitle("Cambiar Contraseña");

  const { user, showNotification } = useGlobalStore();
  const [currentPasswordShown, setCurrentPasswordShown] = useState(false);
  const [newPasswordShown, setNewPasswordShown] = useState(false);
  const [confirmNewPasswordShown, setConfirmNewPasswordShown] = useState(false);

  const [formState, setError, changeHandler, reset] = useForm({
    currentPass: "",
    newPass: "",
    confirmNewPass: "",
  });

  function disableButton() {
    return (
      !formState.data.currentPass ||
      !formState.data.newPass ||
      !formState.data.confirmNewPass ||
      formState.data.newPass !== formState.data.confirmNewPass ||
      formState.data.newPass === formState.data.currentPass
    );
  }

  function submitForm() {
    // TODO: no funciona, dice como que siempre la cambia
    changePass(
      formState.data.currentPass,
      formState.data.newPass
    ).then((res) => {
      reset();
      showNotification({
        title: "Cambio de contraseña",
        message: res.data.message[0].message,
        isError: false,
      });
    });
  }

  return (
    <>
      <div className="block max-w-[680px] pt-10">
        <form
          onSubmit={(e) => {
            e.preventDefault();
          }}
        >
          <div className="accordion-container">
            <Accordion title="Cambio de Contraseña">
              <p>
                La nueva contraseña <b>debe ser diferente a la anterior</b>
              </p>
              <div className="block space-y-8 pt-12">
                <div className="form-group">
                  <label>Contraseña Actual</label>
                  <div className="form-icon">
                    <i
                      onClick={() =>
                        setCurrentPasswordShown(!currentPasswordShown)
                      }
                      className={`icon icon-eye${
                        currentPasswordShown ? "" : "off"
                      } right text-gray-80 icon-password text-[10px]`}
                    ></i>
                    <input
                      type={currentPasswordShown ? "text" : "password"}
                      className="form-control large"
                      placeholder="Ingresa tu contraseña actual"
                      value={formState.data.currentPass}
                      onChange={changeHandler("currentPass")}
                    />
                  </div>
                  <small>Debe tener al menos 8 caracteres</small>
                </div>
                <div className="form-group">
                  <label>Nueva Contraseña</label>
                  <div className="form-icon">
                    <i
                      onClick={() => setNewPasswordShown(!newPasswordShown)}
                      className={`icon icon-eye${
                        newPasswordShown ? "" : "off"
                      } right text-gray-80 icon-password text-[10px]`}
                    ></i>
                    <input
                      type={newPasswordShown ? "text" : "password"}
                      className="form-control large"
                      placeholder="Ingresa tu nueva contraseña"
                      value={formState.data.newPass}
                      onChange={changeHandler("newPass")}
                    />
                  </div>
                  <small>Debe tener al menos 8 caracteres</small>
                </div>
                <div className="form-group">
                  <label>Confirmación de Contraseña</label>
                  <div className="form-icon">
                    <i
                      onClick={() =>
                        setConfirmNewPasswordShown(!confirmNewPasswordShown)
                      }
                      className={`icon icon-eye${
                        confirmNewPasswordShown ? "" : "off"
                      } right text-gray-80 icon-password text-[10px]`}
                    ></i>
                    <input
                      type={confirmNewPasswordShown ? "text" : "password"}
                      className="form-control large"
                      placeholder="Confirma tu nueva contraseña"
                      value={formState.data.confirmNewPass}
                      onChange={changeHandler("confirmNewPass")}
                    />
                  </div>
                  <small>Ambas contraseñas deben de ser iguales</small>
                </div>
              </div>
            </Accordion>
          </div>
          <div className="flex justify-end pt-8">
            <button
              type="button"
              disabled={disableButton()}
              onClick={submitForm}
              className="btn btn-primary btn-large w-full lg:w-auto"
            >
              Cambiar Contraseña
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default ChangePassword;
